import { createContext, useContext } from 'react';

import { EasyshipLocale } from './types';

export interface I18nContextValue {
  locale: EasyshipLocale;
  setLocale: (locale: EasyshipLocale) => void;
}

export const I18nContext = createContext<I18nContextValue | null>(null);

export const useI18n = (): I18nContextValue => {
  const context = useContext(I18nContext);

  if (!context) {
    throw new Error('useI18n must be used within an I18nProvider.');
  }

  return context;
};
